import React from 'react';

import { Box, Typography } from '@mui/material';

interface Props {
  count?: number;
  isError?: boolean;
  label: string;
}

export default function TabStripLabel({ count, isError = false, label }: Props) {
  return (
    <Box alignItems="center" display="inline-flex" gap={1}>
      <span>{label}</span>
      {typeof count === 'number' && (
        <Typography
          component="span"
          sx={{
            alignItems: 'center',
            bgcolor: isError ? 'error.main' : 'grey.100',
            borderRadius: 999,
            color: isError ? 'error.contrastText' : 'text.secondary',
            display: 'inline-flex',
            fontSize: 12,
            fontWeight: 700,
            height: 22,
            justifyContent: 'center',
            minWidth: 22,
            px: 1,
          }}
        >
          {count}
        </Typography>
      )}
    </Box>
  );
}
